/* eslint-disable jsx-a11y/anchor-is-valid */
import {FC} from 'react'

type Props  = {
  handleExportData?:() => void;
}
const Dropdown2 = ({handleExportData}: Props) => {
  return (
    <div
      className='menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg-light-primary fw-bold w-200px'
      data-kt-menu='true'
    >
      <div className='menu-item px-3'>
        <div className='menu-content fs-6 text-dark fw-bolder px-3 py-4'>عملیات</div>
      </div>

      <div className='separator mb-3 opacity-75'></div>

      <div className='menu-item px-3 pb-3'>
        <a  className='menu-link px-3' onClick={handleExportData}>
          خروجی اکسل
        </a>
      </div>
    </div>
  )
}

export {Dropdown2}
